const coupons = {
  invalidReferralCode: {
    title: 'Sorry!',
    description:
      'This offer code is invalid. You may not be eligible or this offer may no longer be active.',
  },
};

export default coupons;
